.container {
  position: relative;
  width: 100%;
  height: 100%;
}

.canvas {
  background: linear-gradient(135deg, #fffdf7 0%, #fffdf7 100%);
  min-height: 500px;
}

@media (max-width: 768px) {
  .container {
    min-height: 50vh;
    height: 50vh;
  }

  .canvas {
    min-height: 50vh;
    height: 50vh;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .container {
    min-height: 45vh;
    height: 45vh;
  }

  .canvas {
    min-height: 45vh;
    height: 45vh;
  }
}
